import { render } from "./ResultBoard.vue?vue&type=template&id=346f1434&scoped=true"
import script from "./ResultBoard.vue?vue&type=script&lang=js"
export * from "./ResultBoard.vue?vue&type=script&lang=js"

import "./ResultBoard.vue?vue&type=style&index=0&id=346f1434&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-346f1434"]])

export default __exports__